import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { autoChecklistService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useDownloadGidentifyOwnerDocumentMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		async ({
			id,
			ownerType,
			token,
		}: {
			id: string;
			ownerType: string;
			token: string;
		}) => {
			if (!token) return Promise.reject("Token is missing");
			return autoChecklistService.downloadGidentifyOwnerDocument(
				id,
				ownerType,
				token,
			);
		},
		{
			onMutate() {
				dispatch(uiActions.showSpinnerOverlay());
			},
			onSuccess() {
				dispatch(
					uiActions.showSuccessNotification({
						title: "gIdentify Result has been downloaded successfully",
					}),
				);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
		},
	);
};

export default useDownloadGidentifyOwnerDocumentMutation;
